import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem('flowup_token');
    setUser(null);
  }, []);

  // Validate token on mount
  useEffect(() => {
    const token = localStorage.getItem('flowup_token');
    if (token) {
      api.get('/auth/me')
        .then(u => { setUser(u); setLoading(false); })
        .catch(() => {
          localStorage.removeItem('flowup_token');
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  // Listen for auth:logout event dispatched by api.js on 401
  useEffect(() => {
    const handler = () => logout();
    window.addEventListener('auth:logout', handler);
    return () => window.removeEventListener('auth:logout', handler);
  }, [logout]);

  const login = async (username, password) => {
    const data = await api.post('/auth/login', { username, password });
    localStorage.setItem('flowup_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (form) => {
    const data = await api.post('/auth/register', form);
    localStorage.setItem('flowup_token', data.token);
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
